<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/log/issueBonusLog")
          i.fa.fa-file
          span.ml-1 {{ $t("ui.bonus_log") }}
      b-breadcrumb-item(v-if="currOperator && pageLvl != 'opr' && getAccountType == 3")
        i.fa.fa-user
        span.ml-1 {{ currOperator.account_id }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.row.mb-1
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')" :disabled="manualBonus == true && pageLvl == 'log'")
                div.col-md-9.row
                  div(width="50%" v-if="pageLvl == 'log'").mr-3
                    DateRangePicker(:value="dateRange" @update="getData")
                  div(width="20%" v-if="pageLvl == 'log'").mr-3
                    b-input-group(size="sm").mb-1
                      b-input-group-text(slot="prepend")
                        span {{ $t('ui.manual_bonus') }}
                      b-input-group-text(slot="append")
                        div.d-flex.justify-content-center.align-items-center
                          label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                            input.switch-input(type="checkbox" v-model="manualBonus" @change="clearSearchTxt()")
                            span.switch-slider(:data-checked='on' :data-unchecked='off')
                  div(width="30%")
                    SubmitButton(
                      :loading="loading"
                      icon="fa fa-search"
                      :text="$t('ui.search')"
                      type="button"
                      @click="getListing()"
                      variant="success"
                      size="sm"
                      )
        div.card-body
          div.mb-1(v-if="pageLvl == 'opr' && getAccountType == 3")
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalOprRow"
                  :per-page="getPageSize"
                  v-model="currentOprPage"
                  @input="changedOprPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedOprPageSize")
          div.mb-1(v-if="pageLvl == 'log'")
            div.mb-1(v-if="getAccountType == 3")
              SubmitButton(
                :loading="loading"
                icon="icon-arrow-left"
                :text="$t('ui.back')"
                type="button"
                @click="backToOperatorLvl"
                variant="secondary"
                size="sm"
                ).mb-1.mr-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalLogRow"
                  :per-page="getPageSize"
                  v-model="currentLogPage"
                  @input="changedLogPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedLogPageSize")
          div.row.clusterize
            div.col-md-12(v-if="pageLvl=='opr' && getAccountType == 3")
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position.sortable(width="10%" @click="sortOrder('account_id', 'opr')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id', 'opr')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('profile_id', 'opr')")
                        span(:title="$t('ui.profile_id')") {{ $t('ui.profile_id') }}
                        i(:class="changeSortKey('profile_id', 'opr')")
                      th.sticky-position.sortable(width="23%" @click="sortOrder('full_name', 'opr')")
                        span(:title="$t('ui.full_name')") {{ $t("ui.full_name") }}
                        i(:class="changeSortKey('full_name', 'opr')")
                      th.sticky-position(width="11%")
                        span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                      th.sticky-position(width="15%")
                        span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                      th.sticky-position(width="7%")
                        span(:title="$t('ui.status')") {{ $t("ui.status") }}
                      th.text-right.sticky-position.sortable(width="13%" @click="sortOrder('created_date', 'opr')")
                        span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                        i(:class="changeSortKey('created_date', 'opr')")
                  tbody.clusterize-content
                    tr(v-if="filteredOperatorList.length == 0")
                      td(colspan="8").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in filteredOperatorList")
                      td
                        span(:title="((currentOprPage - 1) * getPageSize + index + 1)") {{ ((currentOprPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="item.account_id")
                          b-link.clickable(href="javascript:void(0);" @click="setOperatorAccId(item, true)") {{ item.account_id }}
                      td
                        span(:title="item.profile_id") {{ item.profile_id }}
                      td
                        span(:title="item.full_name") {{ item.full_name }}
                      td
                        span(:title="item.contact_phone") {{ item.contact_phone }}
                      td
                        span(:title="item.last_login_ip") {{ item.last_login_ip }}
                      td
                        span(:title="item.status") {{ item.status }}
                      td.text-right
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
            div.col-md-12(v-if="currOperator && pageLvl== 'log'")
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position(width="11%")
                        span(:title="$t('ui.member_id')") {{ $t('ui.member_id') }}
                      th.sticky-position.text-right(width="19%")
                        span(:title="$t('ui.bonus_name')") {{ $t('ui.bonus_name') }}
                      th.sticky-position.text-right(width="20%")
                        span(:title="$t('ui.bonus_desc')") {{ $t('ui.bonus_desc') }}
                      th.sticky-position.text-right(width="9%")
                        span(:title="$t('ui.bonus_type')") {{ $t('ui.bonus_type') }}
                      th.sticky-position.text-right(width="14%")
                        span(:title="$t('ui.bonus_value')") {{ $t('ui.bonus_value') }}
                      th.sticky-position.text-right(width="11%")
                        span(:title="$t('ui.created_by')") {{ $t('ui.created_by') }}
                      th.sticky-position.text-right.sortable(width="13%" @click="sortOrder('created_date', 'log')")
                        span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                        i(:class="changeSortKey('created_date', 'log')")
                  tbody.clusterize-content
                    tr(v-if="logList.length == 0")
                      td(:colspan="8").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in logList")
                      td
                        span(:title="((currentLogPage - 1) * getPageSize + index + 1)") {{ ((currentLogPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="item.member_id") {{ item.member_id }}
                      td.text-right
                        span(:title="item.bonus_name") {{ item.bonus_name }}
                      td.text-right
                        span(:title="item.bonus_desc") {{ item.bonus_desc }}
                      td.text-right
                        span(:title="item.bonus_type") {{ item.bonus_type }}
                      td.text-right
                        span.font-weight-bold(:title="$n(item.bonus_value, 'currency')") {{ $n(item.bonus_value, 'currency') }}
                      td.text-right
                        span(:title="item.created_by") {{ item.created_by }}
                      td.text-right
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                    tr(v-if="showTotal")
                      td.text-right(colspan="5")
                        span {{ $t("ui.sub_total") }}
                        br
                        span {{ $t("ui.grand_total") }}
                      td.text-right
                        span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonus)" :title="$n(subTotalBonus, 'currency')") {{ $n(subTotalBonus, 'currency') }}
                        br
                        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonus)" :title="$n(grandTotalBonus, 'currency')") {{ $n(grandTotalBonus, 'currency') }}
                      td(colspan="2")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    operatorList: [],
    logList: [],
    currentOprPage: 1,
    totalOprRow: 0,
    currentLogPage: 1,
    totalLogRow: 0,
    search: "",
    manualBonus: false,
    showTotal: false,
    subTotalBonus: 0,
    grandTotalBonus: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    pageLvl: 'opr',
    currOperator: null,
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    oprSortKey: "account_id",
    oprSortType: "asc",
    logSortKey: "created_date",
    logSortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    filteredOperatorList() {
      return this.operatorList;
    },
    getAccountType() {
      if (this.$store.getters.account[0])
        return this.$store.getters.account[0].account_type;

      return 0;
    }
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');

    if(this.$store.getters.account[0]) {
      if (this.$store.getters.account[0].account_type == 2) {
        this.currOperator = this.$store.getters.account[0];
        this.pageLvl = 'log';
        this.getLogList(true);
      } else if (this.$store.getters.account[0].account_type == 3) {
        this.getOperatorList(true);
      }
    }
  },
  methods: {
    sortOrder(key, type) {
      if (type == 'opr') {
        if (this.oprSortKey == key)
          this.oprSortType = this.oprSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.oprSortKey = key;
          this.oprSortType = 'asc';
        }
        this.getOperatorList(true);
      } else if (type == 'log') {
        if (this.logSortKey == key)
          this.logSortType = this.logSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.logSortKey = key;
          this.logSortType = 'asc';
        }
        this.getLogList(true);
      }
    },
    changeSortKey(key, type) {
      if (type == 'opr') {
        if (this.oprSortKey != key)
          return 'fas fa-sort';
        else if (this.oprSortKey == key && this.oprSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.oprSortKey == key && this.oprSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'log') {
        if (this.logSortKey != key)
          return 'fas fa-sort';
        else if (this.logSortKey == key && this.logSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.logSortKey == key && this.logSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    clearSearchTxt() {
      this.search = "";
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getLogList(true);
    },
    backToOperatorLvl() {
      this.pageLvl = "opr";
      this.search = "";
      this.logList = [];
      this.currOperator = null;
    },
    getListing() {
      if (this.pageLvl == 'opr')
        this.getOperatorList(true);
      else if (this.pageLvl == 'log')
        this.getLogList(true);
    },
    getOperatorList: function(isSearch) {
      this.pageLvl = 'opr';

      let url = config.accountListUrl();

      if (isSearch) this.currentOprPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        sort_key: this.oprSortKey,
        sort_type: this.oprSortType,
        page_number: this.currentOprPage,
        page_size: this.getPageSize
      };


      if (this.search.trim() != '') {
        json.search_id = this.search;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.operatorList = response.data.dt;
                this.totalOprRow = this.operatorList.length > 0 ? this.operatorList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setOperatorAccId: function (item) {
      this.currOperator = item;
      this.search = "";
      this.manualBonus = false;
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.getLogList(true);
    },
    getLogList: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.issueBonusListUrl();

        if (isSearch) this.currentLogPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          source_account_id: this.$store.getters.accountId,
          target_account_id: this.currOperator.account_id,
          manual_bonus_only: this.manualBonus,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_type: this.logSortType,
          page_number: this.currentLogPage,
          page_size: this.getPageSize
        };

        if (this.search.trim() != '' && this.manualBonus != true)
          json.search_id = this.search;

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.pageLvl = 'log';
                  if(response.data.dt.length > 0) {
                    this.showTotal = true;
                    response.data.dt.forEach(value => {
                      this.subTotalBonus = parseFloat(this.subTotalBonus) + parseFloat(value["bonus_value"]);
                    });

                    this.logList = response.data.dt;
                    this.totalLogRow = this.logList.length > 0 ? this.logList[0].totalrows : 0;
                    this.grandTotalBonus = this.logList.length > 0 ? this.logList[0].total_bonus_value : 0;
                  } else {
                    this.clearTotal()
                  }
                } else {
                  this.clearTotal();
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotal()
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }

    },
    clearTotal() {
      this.showTotal = false
      this.logList = []
      this.totalLogRow = 0
      this.subTotalBonus = 0
      this.grandTotalBonus = 0
    },
    changedOprPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentOprPage = 1;
      this.getOperatorList(true);
    },
    changedOprPage: function(pageNo) {
      this.currentOprPage = pageNo;
      this.getOperatorList();
    },
    changedLogPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentLogPage = 1;
      this.getLogList(true);
    },
    changedLogPage: function(pageNo) {
      this.currentLogPage = pageNo;
      this.getLogList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>